import { PrimaryButton } from '@pmi.web/react-common';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';

import { SlideAddProducts } from './slides/SlideAddProducts';
import { SlideEarn } from './slides/SlideEarn';
import { SlideIntro } from './slides/SlideIntro';
import { SlideShare } from './slides/SlideShare';

interface IHelpCarouselProps {
  readonly onComplete: (() => void) | undefined;
}

export function HelpCarousel({ onComplete }: IHelpCarouselProps) {
  const { t } = useTranslation();
  const [showNextButton, setShowNextButton] = useState<boolean>(true);
  const [showBackButton, setShowBackButton] = useState<boolean>(false);
  const swiperRef = useRef<SwiperRef>(null);

  const handleBack = useCallback(() => {
    if (!swiperRef.current) {
      return;
    }

    swiperRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!swiperRef.current) {
      return;
    }

    swiperRef.current.swiper.slideNext();
  }, []);

  return (
    <div>
      <Swiper
        spaceBetween={16}
        ref={swiperRef}
        onSlideChange={() => {
          if (swiperRef.current?.swiper.isEnd) {
            setShowNextButton(false);
          } else {
            setShowNextButton(true);
          }

          if (swiperRef.current?.swiper.isBeginning) {
            setShowBackButton(false);
          } else {
            setShowBackButton(true);
          }
        }}
      >
        <SwiperSlide style={{ height: 'auto' }}>
          <SlideIntro />
        </SwiperSlide>
        <SwiperSlide style={{ height: 'auto' }}>
          <SlideAddProducts />
        </SwiperSlide>
        <SwiperSlide style={{ height: 'auto' }}>
          <SlideShare />
        </SwiperSlide>
        <SwiperSlide style={{ height: 'auto' }}>
          <SlideEarn />
        </SwiperSlide>
      </Swiper>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent:
            showBackButton === false ||
            (showNextButton === false && onComplete === undefined)
              ? 'center'
              : 'space-between',
          marginTop: '16px',
        }}
      >
        {showBackButton && <button onClick={handleBack}>{t('Back')}</button>}
        {showNextButton && (
          <PrimaryButton onClick={handleNext}>{t('Next')}</PrimaryButton>
        )}
        {!showNextButton && onComplete && (
          <PrimaryButton onClick={onComplete}>{t('Got it')}</PrimaryButton>
        )}
      </div>
    </div>
  );
}
